import React from "react";
import "./index.css";

const ListChild = ({ lists }) => {
  return (
    <div className="list-child">
      {lists.map((item, index) => {
        return (
          <div className="list-child__content" key={item.title + index}>
            <div className="list-child__image">
              <img src={item.image} alt={item.title} />
            </div>
            <h3 className="list-child__title">{item.title}</h3>
            <ul className="list-child__list">
              {item.list.map((li, index) => (
                <li className="list-child__list-item" key={li + index}>
                  {li}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default ListChild;
